import _ from 'lodash';

export const RATING_CATEGORIES = [
	'Lead Vocal/Instrument',
	'Backing Vocal/Instrument',
	'Overall Arrangement',
	'Mixing Quality',
	'Mastering Quality',
	'Commercial Marketability',
	'Niche Marketability',
	'Following',
	'Presentation'
];

export const RATING_SCALE = _.range(1, 10);

export const RATING_LABELS = [
	'Hobbyist',
	'Newbie',
	'Entry Level',
	'Intermediate',
	'Experienced',
	'Journeyman',
	'Expert',
	'Mastery',
	'Professional'
];

export const TIERS = {
	NOT_APPROVED: 'Not Approved',
	IN_REVIEW: 'In Review',
	TIER_1: 'Tier 1',
	TIER_2: 'Tier 2'
};
